// 参会链接 (office/meetlinks.ts, routes/meetlinks.ts): in a 会议室's 邀请 and a call's 添加, 「复制参会链接」 copies a link to
// this meeting; the live links of it are listed there, and its host gets 关闭链接. Opening one (public/guest.js) brings
// whoever it is here with sessionStorage 'meet.join' = {id, m (the meeting's floor room), f (its floor number)}: once
// aboard on that floor, {t:"meet_join", id} puts them straight in (the office checks the link).
import { put } from '/icons.js';
import { t, errorText, fmtTime, onLang } from '/i18n.js';

const KEY = 'meet.join';
const el = (tag, cls, text) => { const e = document.createElement(tag); if (cls) e.className = cls; if (text != null) e.textContent = text; return e; };
const CSS = `.mlk{display:flex;flex-direction:column;gap:6px;margin:0 0 8px;padding:8px;border:2px dashed #1b1410;border-radius:10px;background:#fff8e7;font-size:13px}
.mlk .r{display:flex;align-items:center;gap:6px;flex-wrap:wrap}
.mlk button{font:inherit;font-size:12px;border:2px solid #1b1410;border-radius:999px;padding:3px 10px;background:#FDD03B;cursor:pointer;white-space:nowrap}
.mlk button.off{background:#fff}
.mlk .s{color:#555;font-size:12px}`;

/**
 * @param o {send, toast, floor: {room, id}, me()}
 */
export function initMeetLink(o) {
  const st = document.createElement('style'); st.textContent = CSS; document.head.appendChild(st);
  let links = [], box = null, kindNow = null, busy = false;
  onLang(() => paint());

  async function copy(kind) {
    if (busy) return; busy = true;
    try {
      const r = await fetch('/api/meetlinks', { method: 'POST', headers: { 'Content-Type': 'application/json' }, credentials: 'same-origin',
        body: JSON.stringify({ room: o.floor.room ?? 'main', f: Number(o.floor.id) || 1, kind }) });
      const j = await r.json().catch(() => null);
      if (!j?.ok) { o.toast(j?.code ? errorText('meetlink.err', j) : t('meetlink.copyFailed')); return; }
      let copied = false;
      try { await navigator.clipboard.writeText(j.url); copied = true; } catch {}
      if (!copied) window.prompt(t('meetlink.copyPrompt'), j.url);
      o.toast(t('meetlink.copied'));
      o.send({ t: 'meet_links' });
    } finally { busy = false; }
  }
  function paint() {
    if (!box) return;
    const row = el('div', 'r'), b = el('button'); put(b, 'upload', t('meetlink.copy')); b.onclick = () => copy(kindNow);
    row.append(b, el('span', 's', t('meetlink.copyHint')));
    const rows = links.map((l) => {
      const r = el('div', 'r');
      r.append(el('span', 's', t('meetlink.row', { mine: l.mine ? 'yes' : 'no', by: l.by, time: fmtTime(l.exp) })));
      if (l.closing) r.append(el('span', 's', t('meetlink.closing')));
      else if (l.host) { const x = el('button', 'off'); put(x, 'close', t('meetlink.close')); x.title = t('meetlink.closeHint'); x.onclick = () => o.send({ t: 'meet_link_close', rid: l.rid }); r.append(x); }
      return r;
    });
    box.replaceChildren(row, ...rows);
  }

  return {
    /** The block for the top of the 邀请 / 添加 picker (kind: "room" or "call"); asks the office for the live links. */
    top(kind) {
      kindNow = kind; links = []; box = el('div', 'mlk'); paint();
      o.send({ t: 'meet_links' });
      return box;
    },
    msg(m) {
      if (m.t === 'meet_links') { links = Array.isArray(m.links) ? m.links : []; paint(); }
      else if (m.t === 'meet_ok') o.toast(m.kind === 'call' ? t('meetlink.joinedCall') : t('meetlink.joinedRoom', { name: m.name || t('meetlink.room') }));
      else if (m.t === 'meet_err') o.toast(m.code ? errorText('meetlink.err', m) : t('meetlink.failed'));
    },
    /** Aboard (welcome): a link brought me here? On its floor: in. On another: to that floor first. */
    welcome() {
      let j = null; try { j = JSON.parse(sessionStorage.getItem(KEY) || 'null'); } catch {}
      if (!j || typeof j.id !== 'string') return;
      if (j.m && j.m !== (o.floor.room ?? 'main')) {
        if (j.tried) { try { sessionStorage.removeItem(KEY); } catch {} o.toast(t('meetlink.otherShip')); return; }
        j.tried = true; try { sessionStorage.setItem(KEY, JSON.stringify(j)); } catch {}
        const u = new URL(location.href); u.search = ''; u.hash = ''; if (j.f && j.f !== 1) u.searchParams.set('floor', String(j.f)); location.replace(u.href); return;
      }
      try { sessionStorage.removeItem(KEY); } catch {}
      setTimeout(() => o.send({ t: 'meet_join', id: j.id }), 300); // after the welcome's own settling
    },
  };
}
